import type { IRunPlan, IScaffold } from '../types';
import { merge } from '../services/merge';

/**
 * shared methods for all scaffolds
 */
export abstract class Scaffold {
  /**
   * write attributes onto the scaffold element
   */
  protected _mergeAttributes<E extends HTMLElement>(el: E, runPlan: IRunPlan, defaultAttrs: Record<string, string>): E {
    const customAttrs = runPlan.scaffold.attributes;
    const iframeAttrs = merge(defaultAttrs, customAttrs);

    for (const [key, value] of Object.entries(iframeAttrs)) {
      el.setAttribute(key, `${value}`);
    }

    return el;
  }
}
